import MiQuotes from './quotes';
import { install } from '../../utils/install';
export default install(MiQuotes);
